    <div class="card">
        <div class="card-body pl-2 pr-2 pb-0 pt-0">
            <div class="row">
                <div class="col pr-0">
                    <p class="f-35 mb-0">{{uniquenumber}}</p>
                </div>
                <div class="col pl-0 pr-0">
                    <p class="c-save mb-0 pt-2" style="margin-bottom:-20px!important;">5</p>
                    <span class="material-icons c-save align-middle cursor-default lh-40 pt-1">
                        trending_up
                        </span>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="text-muted">Unique logins</p>
                </div>
            </div>
        </div>
    </div>
